/**
 * DataTableCellActions class
 *
 * @package    DataTable
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';

import { DataTableColumnType, DataTableItemType } from 'Types';

export default class DataTableCellActions extends PureComponent {
    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    /**
     * PropTypes
     */
    static propTypes = {
        column: DataTableColumnType,
        item: DataTableItemType.isRequired,
    };

    /**
     * Build click handler
     *
     * @param onClick
     * @returns {function(): *}
     */
    buildOnClick = onClick => {
        const { item } = this.props;

        return () => onClick(item);
    };

    /**
     * Render actions
     */
    renderActions = () => {
        const { column, item } = this.props;

        return item[column.key] ? column.actions.map(action => (
            <IconButton key={action.name} aria-label={action.name} onClick={this.buildOnClick(action.onClick)}>
                {action.icon}
            </IconButton>
        )) : '';
    };

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        return <div className="mm-center">{this.renderActions()}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableBody/DataTableCells/DataTableCellActions.jsx